import { DATASOURCE } from 'Constants'
import { initializePatterns } from 'helpers/device_helper'

const initialState = {
  received: false,
  patterns: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.AGENT_NORMALIZER.LOADING:
      return {
        ...state,
        loading: true
      };
    case DATASOURCE.AGENT_NORMALIZER.KEY:
      let patterns = processPatterns(action.data.patterns);
      initializePatterns(patterns);
      return {
        ...state,
        loading: false,
        received: true,
        patterns: patterns
      };
    default:
      return state;
  }
};

function processPatterns(patterns) {
  let namePatterns = [];
  patterns.forEach(patternObj => {
    let order = [];
    patternObj.order.forEach(item => {
      if (item !== null && item !== -1) {
        order.push(item);
      }
    });
    namePatterns.push({pattern: new RegExp(patternObj.pattern), order: order});
  });
  return namePatterns;
};
